
const ElevatorIco = ({fill}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.68669 3.56474H9.09611C9.29179 3.56474 9.45044 3.72339 9.45044 3.91907C9.45044 4.11475 9.29179 4.2734 9.09611 4.2734H6.68669C6.49102 4.2734 6.33237 4.11475 6.33237 3.91907C6.33237 3.72339 6.49102 3.56474 6.68669 3.56474Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.45433C2.5 2.20342 2.70342 2 2.95433 2H12.8284C13.0793 2 13.2827 2.20342 13.2827 2.45433V13.7457C13.2827 13.9966 13.0793 14.2 12.8284 14.2H2.95433C2.70342 14.2 2.5 13.9966 2.5 13.7457V2.45433ZM12.374 13.2913V2.90866H3.40866V13.2914H4.53475V5.38359C4.53475 5.13269 4.73817 4.92927 4.98908 4.92927H10.7936C11.0445 4.92927 11.2479 5.13269 11.2479 5.38359V13.2913H12.374ZM5.44341 5.83792V13.2913H7.43709V5.83792H5.44341ZM8.34574 5.83792V13.2913H10.3393V5.83792H8.34574Z"
        fill={fill}
      />
    </svg>
  );
};

export default ElevatorIco;
